export default __webpack_public_path__ + "locales/pt-BR/SharingPanel.json?hash=6bd8ddfd1b25303a37c518f53951546f";